module.exports = __webpack_public_path__ + "static/img/0-4home.7c9b4051.jpg";